html{
  height: 100%;
}
* {
  font-family: 'Lato', Arial, Helvetica, sans-serif;
}

.recaptcha {
  margin: 15% auto;
  width: 400px;
  text-align: center;
  background-color: #fff;
  padding: 20px;
  border-radius: 10px;
}
.container{
    background-color: #fff;
    height: 100%;
    padding: 50px;
}
.registrationForm{
  margin: 50px;
  padding: 20px;
  background-color: #fff;
}
.home_container, .profile_container{
    margin:100px 20px 20px 20px;
}

.react-tabs__tab-list {
    border-bottom: 1px solid #aaa;
    margin: 0 0 10px;
    padding: 0;
  }
  
  .react-tabs__tab {
    display: inline-block;
    border: 1px solid transparent;
    border-bottom: none;
    bottom: -1px;
    position: relative;
    list-style: none;
    padding: 6px 12px;
    cursor: pointer;
  }
  
  .react-tabs__tab--selected {
    background: #fff;
    border-color: #aaa;
    color: black;
    border-radius: 5px 5px 0 0;
  }
  
  .react-tabs__tab--disabled {
    color: GrayText;
    cursor: default;
  }
  
  .react-tabs__tab:focus {
    box-shadow: 0 0 5px hsl(208, 99%, 50%);
    border-color: hsl(208, 99%, 50%);
    outline: none;
  }
  
  .react-tabs__tab:focus:after {
    content: "";
    position: absolute;
    height: 5px;
    left: -4px;
    right: -4px;
    bottom: -5px;
    background: #fff;
  }
  
  .react-tabs__tab-panel {
    display: none;
  }
  
  .react-tabs__tab-panel--selected {
    display: block;
  }

  .fullw{
    width: 100% !important;
  }

  .ulnone{
    list-style: none;
  }

  .react-datepicker-wrapper,.react-datepicker__input-container{
    width: 100% !important;
  }

  input[type=checkbox]{
    margin: 10px;
  }

  .btn-100{
    width: 100px;
  }
  .header-title{
    text-align: center;
  }
  .modal-body {
    overflow-y: scroll;
    max-height: 400px;
  }
  .modal-body p.labelFor{
    font-size: 16px;
    margin-top: 10px;
    font-family: 'Lato';
  }
#receiptReport .small-font th{
  font-size: 12px;
  font-weight: 400;
  text-align: center;
  min-width: 60px;
}
#receiptReport td{
  text-align: center;
  font-weight: 600;
}

.error-message {
  color: #FF0000;
  font-size: 12px;
  font-weight: bold;
}

.need-fix {
  border: 3px solid #FF0000 !important;
}

#tab3 label {
  height: 45px;
}


/** SPINNER CREATION **/

.loader {
  position: relative;
  text-align: center;
  margin: 15px auto 35px auto;
  z-index: 9999;
  display: block;
  width: 80px;
  height: 80px;
  border: 10px solid rgba(0, 0, 0, .3);
  border-radius: 50%;
  border-top-color: #000;
  animation: spin 1s ease-in-out infinite;
  -webkit-animation: spin 1s ease-in-out infinite;
}

@keyframes spin {
  to {
    -webkit-transform: rotate(360deg);
  }
}

@-webkit-keyframes spin {
  to {
    -webkit-transform: rotate(360deg);
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/assets/css/style.css
// module id = 1054
// module chunks = 0